import React from "react";

// https://stackoverflow.com/questions/36104302/how-do-i-convert-a-string-to-jsx
let getNodes = (str: string) => new DOMParser().parseFromString(str, "text/html").body.childNodes;
let createJSX: any = (nodeArray: Array<ChildNode>) => {
    return nodeArray.map((node: any) => {
        let attributeObj: any = {};
        const { attributes, localName, childNodes, nodeValue } = node;
        if (attributes) {
            Array.from(attributes).forEach((attribute: any) => {
                if (attribute.name === "style") {
                    let styleAttributes: any = attribute.nodeValue.split(";");
                    let styleObj: any = {};
                    styleAttributes.forEach((attribute: any) => {
                        let [key, value] = attribute.split(":");
                        styleObj[key] = value;
                    });
                    attributeObj[attribute.name] = styleObj;
                } else {
                    attributeObj[attribute.name] = attribute.nodeValue;
                }
            });
        }
        return localName ?
            React.createElement(
                localName,
                attributeObj,
                childNodes && Array.isArray(Array.from(childNodes)) ?
                    createJSX(Array.from(childNodes)) :
                    []
            ) :
            nodeValue;
    });
};

export const StringToJSX = (props: { domString: string; }) => {
    return createJSX(Array.from(getNodes(props.domString)));
};
